import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import './Experience.css';
import { experience } from '../config';

const Experience = () => {
  const ref = useRef(null);
  const show = useInView(ref, { once: true, margin: '-80px' });

  return (
    <section id="experience" className="experience" ref={ref}>
      <div className="container">
        <motion.div className="section-label" initial={{ opacity: 0, y: 10 }} animate={show ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.5 }}>
          <span>Experience</span>
        </motion.div>

        <motion.h2 className="section-heading" initial={{ opacity: 0, y: 20 }} animate={show ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.5, delay: 0.05 }}>
          Where I've worked
        </motion.h2>

        <div className="exp-list">
          {experience.map((job, i) => (
            <motion.div
              key={job.id}
              className="exp-item"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-40px' }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
            >
              <span className="exp-year">{job.period}</span>
              <div className="exp-main">
                <h3 className="exp-role">{job.role}</h3>
                <span className="exp-company">{job.company}</span>
                <p className="exp-desc">{job.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
